<div class="ui-fluid col-12 card card-w-title">
  <h4 class="module-title" i18n>Messages</h4>

	@if (!(($messages | async)?.length)) {
		<h6 i18n>No unread messages</h6>
	}
	<p-accordion [multiple]="true">
		@for (m of $messages | async; track m; let i = $index) {
			<p-accordionTab (click)="setIsViewed(m.id)" [selected]="m.id == selectedMsgId" [headerStyle]="m.important ? {'background': 'red'} : {'background': 'default'}">
				<p-header>
					<span>{{ m.title }}</span>
					@if (isViewed[m.id]) {
						<span class="delete-button">
							<p-button icon="mdi mdi-delete" (click)="deleteMessage({originalEvent: $event, id: m.id})"></p-button>
						</span>
					}
				</p-header>
				<ng-template pTemplate="content">
					<div [innerHTML]="m.content"></div>
				</ng-template>
			</p-accordionTab>
		}
	</p-accordion>
</div>
